var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 1.89124V5.33335C11.6668 5.80006 11.6668 6.03342 11.7577 6.21168C11.8376 6.36848 11.965 6.49596 12.1218 6.57586C12.3001 6.66669 12.5335 6.66669 13.0002 6.66669H16.4423M16.6668 8.32354V14.3334C16.6668 15.7335 16.6668 16.4335 16.3943 16.9683C16.1547 17.4387 15.7722 17.8212 15.3018 18.0609C14.767 18.3334 14.067 18.3334 12.6668 18.3334H7.3335C5.93336 18.3334 5.2333 18.3334 4.69852 18.0609C4.22811 17.8212 3.84566 17.4387 3.60598 16.9683C3.3335 16.4335 3.3335 15.7335 3.3335 14.3334V5.66669C3.3335 4.26656 3.3335 3.56649 3.60598 3.03171C3.84566 2.56131 4.22811 2.17885 4.69852 1.93917C5.2333 1.66669 5.93336 1.66669 7.3335 1.66669H10.01C10.6215 1.66669 10.9272 1.66669 11.2149 1.73576C11.47 1.797 11.7139 1.89801 11.9375 2.03509C12.1898 2.18969 12.406 2.40588 12.8384 2.83826L15.4953 5.49511C15.9276 5.92749 16.1438 6.14368 16.2984 6.39597C16.4355 6.61966 16.5365 6.86352 16.5978 7.11861C16.6668 7.40633 16.6668 7.71206 16.6668 8.32354Z",
    stroke: "#9AA4B2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.2edafa90bd472883deeb20976a885206.svg";
export { ForwardRef as ReactComponent };